import { render, staticRenderFns } from "./BtnImage.vue?vue&type=template&id=6657cf55&scoped=true&"
import script from "./BtnImage.vue?vue&type=script&lang=js&"
export * from "./BtnImage.vue?vue&type=script&lang=js&"
import style0 from "./BtnImage.vue?vue&type=style&index=0&id=6657cf55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6657cf55",
  null
  
)

export default component.exports